import { render, staticRenderFns } from "./HomeOptimized.vue?vue&type=template&id=0f6e559a&scoped=true"
import script from "./HomeOptimized.vue?vue&type=script&lang=js"
export * from "./HomeOptimized.vue?vue&type=script&lang=js"
import style0 from "./HomeOptimized.vue?vue&type=style&index=0&id=0f6e559a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e559a",
  null
  
)

export default component.exports